import { Dispatch, SetStateAction, useState } from "react";

import { ProjectActivitiesConstants } from "../../../../constants";
import { transitionActivity } from "../../../../service/activity";
import { Status } from "../../../../service/Shared";
import { getErrorMessageFromCode } from "../../../../service/ValidationErrorFormatter";
import { useIsLoadingWrapper } from "../../../../utils";
import { Toast } from "../../../../widget";

/* eslint-disable unused-imports/no-unused-vars */
interface useSubmitToRegistryModalProps {
  onClose: () => void;
  activityUuid: string;
  activityStatus: string;
  activityRowVersion: number;
  refreshActivityReviews?: boolean;
  setRefreshActivityReviews?: Dispatch<SetStateAction<boolean>>;
}
interface useSubmitToRegistryModalReturnData {
  isLoading: boolean;
  onConfirmClick: () => void;
}

export const useSubmitToRegistryModal = ({
  onClose,
  activityUuid,
  activityRowVersion,
  activityStatus,
  refreshActivityReviews,
  setRefreshActivityReviews,
}: useSubmitToRegistryModalProps): useSubmitToRegistryModalReturnData => {
  const [isLoading, setIsLoading] = useState(false);

  const onConfirmClick = useIsLoadingWrapper(async (): Promise<void> => {
    const res = await transitionActivity({
      activity: {
        uuid: activityUuid,
        rowVersion: activityRowVersion,
        toStatus: ProjectActivitiesConstants.STATUS_SUBMITTED_TO_REGISTRY,
        fromStatus: activityStatus,
        publishExternalMessages: false,
        publishInternalMessages: false,
      },
      activityReviews: [],
    });

    if (res.status === Status.Success) {
      Toast.success({ message: "Activity submitted to registry" });

      // If called from dashboard refresh context
      if (refreshActivityReviews !== undefined && setRefreshActivityReviews !== undefined) {
        setRefreshActivityReviews(!refreshActivityReviews);
      }
      onClose();
    } else if (res.errors && res.errors.length > 0) {
      Toast.error({ message: getErrorMessageFromCode(res.errors[0].message) });
    }
  }, setIsLoading);

  return {
    isLoading,
    onConfirmClick,
  };
};
